import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { PlanoTreinamentoListaFilter } from "../../models/plano_treinamento_lista_filter";
import { AlvenariaEstruturalLista } from "../../models/plano_alvenaria_estrutural_lista";
import { IGetAllObrasAlvenariaEstruturalUseCase } from "../../../presentation/useCases/read/get_all_obra_alvenaria_estrutural_use_case";
import { AlvenariaEstruturalListaFilter } from "../../models/plano_alvenaria_estrutural_filter";


// GetAllObrasAlvenariaEstruturalServicoUseCase


export class GetAllObrasAlvenariaEstruturalServicoUseCase
  extends BasePaginatedUseCase<AlvenariaEstruturalLista>
  implements IGetAllObrasAlvenariaEstruturalUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObrasAlvenariaEstrutural(
    filter: AlvenariaEstruturalListaFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllObrasAlvenariaEstrutural(
        filter,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
